import styled from 'styled-components';

import Button from './Button/Button';

interface LinkButtonProps {
  $highlighted?: boolean;
}

export const LinkButton = styled(Button)<LinkButtonProps>`
  padding: 0;
  outline: none;
  cursor: ${({ disabled }) => (disabled ? 'auto' : 'pointer')};

  &,
  &:hover,
  &:active,
  &:focus {
    color: ${({ $highlighted }) =>
      $highlighted
        ? `var(--pageParagraphForeground)`
        : `var(--pageLinkForeground)`};
    background: none;
    border: none;
  }

  &:hover:enabled,
  &:active:enabled {
    opacity: 0.7;
  }
`;

LinkButton.displayName = 'LinkButton';
